export var API_HOST = window.location.host;
export var GENERIC_ERROR_MESSAGE = "Error. Something went wrong. We were unable to complete your last action... please try again.";
export var PROFILE_API_URL = "/api/profile";
export var PROFILE_RESUME_JSO_API_URL = "/api/profile/resume-jso";
export var FETCH_FAIL_ERROR_MESSAGE = "We were unable to contact our servers. Please try again.";
